import { createMuiTheme } from '@material-ui/core/styles';

const primary = '#2d84d6';
const theme =  createMuiTheme({
  palette: { 
    primary: {
      main: primary,
    }
  },
  typography: {
    fontFamily: [
      '"Nunito"',
      'sans-serif',    
    ].join(','),
  },
  overrides: {
    MultiSelect: {
      root: {
        borderRadius: '1em'
      }
    },
    // Inputs
    MuiTextField: {
      root:{
        backgroundColor: '#f3f3f3',
        borderRadius: '1em'
      }      
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: '1em'
      }
    },
    MuiFilledInput: {
      root: {
        backgroundColor: 'transparent',
        // when hover
        '&:hover':{
          backgroundColor: 'transparent',
        },
        // when focused
        '&$focused': {
          borderRadius: '1em',
          backgroundColor: '#f3f3f3'
        },
        '&$disabled': {
          backgroundColor: '#f3f3f3',
          borderRadius: '1em'
        } 
               
      },      
      underline: {
        "&&&:before": {
          borderBottom: "none"
        },
        "&&:after": {
          // borderBottom: "none"
        }
      },
    },

    // Buttons
    MuiButton: {
      outlinedPrimary: {
        '&:hover':{
          backgroundColor: primary,
          color: 'white',
          borderColor: 'white'
        }        
      }
    },

    MuiPagination: {
      root:{
        margin: '2em 0 1em',
        // borderTop: '1px solid #c8cccc',
      },
      ul: {
        justifyContent: 'center'
      }
    },

    // Alerts
    MuiAlert: {
      filledSuccess: {
        backgroundColor: '#3dbfbc'
      }
    }
  }, 
});

export default theme;